export const FAST_POLL_MS = 3_000;
export const IDLE_POLL_MS = 10_000;
